/**
 * Mídia real dos convites digitais (public/assets/digital-invites/).
 * Cards sem entrada aqui mantêm o mockup genérico como fallback.
 */
const digitalInviteAsset = (filename) =>
  `/assets/digital-invites/${encodeURIComponent(filename)}`;

export const DIGITAL_INVITES_CATALOG_MEDIA = {
  simple: { type: 'image', src: '/assets/digital-invites/convite-simples.png' },
  interactive: { type: 'image', src: '/assets/digital-invites/convite-interativo.png' },
  interactiveInfinite: { type: 'image', src: '/assets/digital-invites/convite-interativo-infinito.png' },
  gifAnimated: { type: 'video', src: '/assets/digital-invites/convite-gif-animado.mp4' },
  animated: { type: 'video', src: '/assets/digital-invites/convite-minnie-rosa.mp4' },
  superAnimated: { type: 'video', src: '/assets/digital-invites/convite-super-animado.mp4' },
  sweet15: { type: 'video', src: '/assets/digital-invites/convite-15-anos-premium-website.mp4' },
  kidsCharacter: { type: 'video', src: '/assets/digital-invites/convite-baby-branca-de-neve.mp4' },
  weddingPremium: { type: 'video', src: '/assets/digital-invites/VideoCasamento.mp4' },
  babyRevealSimple: { type: 'image', src: '/assets/digital-invites/cha-revelacao-simples.png' },
  babyRevealInteractive: { type: 'image', src: '/assets/digital-invites/cha-revelacao-interativo.png' },
  babyRevealPremiumWebsite: {
    type: 'video',
    src: digitalInviteAsset('Cópia de Chá  de bebê menino azul.mp4')
  }
};

export function getDigitalInvitesCatalogMedia(modelId) {
  return DIGITAL_INVITES_CATALOG_MEDIA[modelId] ?? null;
}
